const TRANSLATIONS_KEY = "app_translations";
const TRANSLATIONS_TIMESTAMP_KEY = "app_translations_timestamp";
const TRANSLATIONS_EXPIRY_TIME = 24 * 60 * 60 * 1000;
const CURRENT_LANGUAGE_KEY = "app_current_language";

export const saveLocalTranslations = (translations) => {
  try {
    localStorage.setItem(TRANSLATIONS_KEY, JSON.stringify(translations));
    localStorage.setItem(TRANSLATIONS_TIMESTAMP_KEY, Date.now().toString());
  } catch (error) {
    console.error("Ошибка при сохранении переводов в localStorage:", error);
  }
};

export const getLocalTranslations = () => {
  try {
    const timestamp = localStorage.getItem(TRANSLATIONS_TIMESTAMP_KEY);

    // Проверяем не устарели ли переводы
    if (timestamp && Date.now() - parseInt(timestamp) < TRANSLATIONS_EXPIRY_TIME) {
      const translations = localStorage.getItem(TRANSLATIONS_KEY);
      return translations ? JSON.parse(translations) : null;
    }

    return null;
  } catch (error) {
    console.error("Ошибка при получении переводов из localStorage:", error);
    return null;
  }
};

export const setCurrentLanguage = (language) => {
  try {
    localStorage.setItem(CURRENT_LANGUAGE_KEY, language);
  } catch (error) {
    console.error("Ошибка при сохранении текущего языка:", error);
  }
};

export const getCurrentLanguage = () => {
  try {
    return localStorage.getItem(CURRENT_LANGUAGE_KEY);
  } catch (error) {
    console.error("Ошибка при получении текущего языка:", error);
    return null;
  }
};

export const shouldUpdateTranslations = () => {
  try {
    const timestamp = localStorage.getItem(TRANSLATIONS_TIMESTAMP_KEY);
    if (!timestamp) return true;

    return Date.now() - parseInt(timestamp) >= TRANSLATIONS_EXPIRY_TIME;
  } catch (error) {
    console.error("Ошибка при проверке актуальности переводов:", error);
    return true;
  }
};

export const clearTranslationsCache = () => {
  try {
    localStorage.removeItem(TRANSLATIONS_KEY);
    localStorage.removeItem(TRANSLATIONS_TIMESTAMP_KEY);
  } catch (error) {
    console.error("Ошибка при очистке кеша переводов:", error);
  }
};
